import useSWRV, { mutate } from 'swrv'
import axios from '@/lib/API/client'
import fetcher from '@/lib/API/fetcher'

export default () => {
    const { data: sensors, isValidating: isValidatingSensors } = useSWRV(() => `user/sensors`, fetcher, {
        revalidateOnFocus: false,
        dedupingInterval: 60000,
    })

    /**
     *
     * mutate* methods
     *
     **/

    const mutateSensors = (data) => {
        mutate(`user/sensors`, data ? data : fetcher(`user/sensors`, undefined, { forceNetwork: true }))
    }

    const createOrUpdateSensor = async (sensorInfo) => {
        if (!sensorInfo?.uuid) {
            console.log("Can't make a request uuid is missing")
            return {}
        }

        let requestData = {}
        if (sensorInfo.name) {
            requestData['name'] = sensorInfo.name
        }
        if (sensorInfo.horse_id || sensorInfo.horse_id === null) {
            requestData['horse_id'] = sensorInfo.horse_id
        }
        if (sensorInfo.rider_id || sensorInfo.rider_id === null) {
            requestData['rider_id'] = sensorInfo.rider_id
        }
        if (sensorInfo.alias || sensorInfo.alias === null) {
            requestData['alias'] = sensorInfo.alias
        }
        if (sensorInfo.firmware) {
            requestData['firmware_st'] = sensorInfo.firmware
        }
        if (sensorInfo.firmwareNRF) {
            requestData['firmware_nordic'] = sensorInfo.firmwareNRF
        }
        if (sensorInfo.cumulativeTime) {
            requestData['cumulative_time'] = sensorInfo.cumulativeTime
        }
        requestData['serial_id'] = sensorInfo.uuid
        requestData['manufacturer'] = 'BSE'
        requestData['type'] = 'movepro'
        requestData['last_transmission_at'] = Date.now()

        const foundSensor = sensors.value?.find((s) => s.serial_id === requestData.serial_id)
        let sensorDataFromApi = {}
        if (foundSensor !== undefined) {
            if (!requestData['firmware_st']) {
                requestData['firmware_st'] = foundSensor.firmware_st
            }
            if (!requestData['firmware_nordic']) {
                requestData['firmware_nordic'] = foundSensor.firmware_nordic
            }
            sensorDataFromApi = await axios.put(`sensors/${foundSensor.id}`, requestData)
        } else {
            sensorDataFromApi = await axios.post('/sensors', requestData)
        }
        mutateSensors()
        return sensorDataFromApi
    }

    return {
        sensors,
        isValidatingSensors,
        createOrUpdateSensor,
    }
}
